const MODAL_SELECTOR = "[data-modal]";
const MODAL_CLOSE_SELECTOR = "[data-modal-close]";
const MODAL_CONTENT_SELECTOR = "[data-modal-content]";
const OPEN_MODAL_BTN_SELECTOR = "[data-modal-open]";
const MODAL_INNER_BTN_SELECTOR = ".modal__btn-js";

const LINK_BTN_SELECTOR = "[data-modal-btn]";
const MODAL_TITLE_SELECTOR = "[data-modal-title]";
const MODAL_FOOTER_SELECTOR = "[data-modal-footer]";
const IFRAME_SELECTOR = "iframe";

const NO_SCROLL_CLASS = "no-scroll";

const ACTIVE_CLASS = "active";

export const initModal = () => {
    const modal = document.querySelector(MODAL_SELECTOR);
    const modalClose = modal?.querySelector(MODAL_CLOSE_SELECTOR);
    const openModalBtns = document.querySelectorAll(OPEN_MODAL_BTN_SELECTOR);
    const innerModalBtn = document.querySelector(MODAL_INNER_BTN_SELECTOR);

    let classesToKeep = [];
    if (innerModalBtn) {
        classesToKeep = Array.from(innerModalBtn.classList);
    }

    if (!modal) return;

    modalClose?.addEventListener("click", () => {
        clearContent(modal, classesToKeep);
        closeModal(modal);
    });

    modal?.addEventListener("click", (e) => {
        const target = e.target;
        if (target.closest(MODAL_CONTENT_SELECTOR)) return;

        clearContent(modal, classesToKeep);
        closeModal(modal);
    });

    openModalBtns.forEach((btn) => {
        btn.addEventListener("click", () => openModal(modal, btn));
    });
};

const openModal = async (modal, btn) => {
    if (!modal) return;
    await addModalContent(modal, btn);
    modal.classList.add(ACTIVE_CLASS);
    document.body.classList.add(NO_SCROLL_CLASS);
};

const addModalContent = (modal, btn) => {
    const url = btn.dataset.url;
    const name = btn.dataset.name;

    // Extract the slot name
    const slotNameEl = btn.closest('[data-slot-item]')?.querySelector('[data-slot-name]');
    const slotName = slotNameEl ? slotNameEl.textContent : '';

    // Inner Btn
    copyInnerBtn(btn, modal);

    // Title
    const modalTitle = modal?.querySelector(MODAL_TITLE_SELECTOR);
    const iframeEl = modal.querySelector(IFRAME_SELECTOR);

    // Update the modal title with the slot name
    if (modalTitle) {
        modalTitle.textContent = slotName || name; // Use slotName if available, otherwise use name from dataset
    }

    // Iframe
    if (iframeEl && url) {
        iframeEl.src = url;
    }
};

const copyInnerBtn = (btn, modal) => {
    let linkBtn = btn.parentNode?.querySelector(LINK_BTN_SELECTOR);
    const innerBtn = modal.querySelector(MODAL_INNER_BTN_SELECTOR);

    if (!linkBtn) {
        const modalFooter = modal?.querySelector(MODAL_FOOTER_SELECTOR);
        modalFooter.style.display = "none";
        return;
    }
    ;

    //Copy text
    innerBtn.textContent = linkBtn.textContent;

    //Copy classes
    const classes = Array.from(linkBtn.classList);
    classes.forEach((cls) => {
        innerBtn.classList.add(cls);
    });

    //Copy attributes
    const dataAttributes = Object.keys(linkBtn.dataset);
    dataAttributes.forEach((attr) => {
        innerBtn.dataset[attr] = linkBtn.dataset[attr];
    });
};


const closeModal = (modal) => {
    if (!modal) return;
    modal?.classList.remove(ACTIVE_CLASS);
    document.body.classList.remove(NO_SCROLL_CLASS);
};

const clearInnerBtn = (modal, classesToKeep) => {
    const innerBtn = modal.querySelector(MODAL_INNER_BTN_SELECTOR);

    const modalFooter = modal?.querySelector(MODAL_FOOTER_SELECTOR);
    modalFooter.removeAttribute('style');

    //Clear attributes
    const dataAttributes = Object.keys(innerBtn.dataset);
    dataAttributes.forEach((attr) => {
        delete innerBtn.dataset[attr];
    });

    //Clear classes
    const classes = Array.from(innerBtn.classList);
    classes.forEach((className) => {
        if (!classesToKeep.includes(className)) {
            innerBtn.classList.remove(className);
        }
    });
};

const clearContent = (modal, classesToKeep) => {
    if (!modal) return;

    clearInnerBtn(modal, classesToKeep);

    const modalTitle = modal.querySelector(MODAL_TITLE_SELECTOR);
    if (modalTitle) modalTitle.textContent = "";

    const iframeEl = modal.querySelector(IFRAME_SELECTOR);
    if (iframeEl) iframeEl.src = "about:blank";
};

initModal();